import {useTranslation} from 'react-i18next';
import {SideBarContainer, SideBarLogo, SideBarPropertyName, SideBarTitle} from './styled';
import usePropertyLinkInfo from 'hooks/guidebooks/usePropertyLinkInfo';

function SideBarUniversalLink() {
  const {t} = useTranslation();
  const {logo, title, isLoaded} = usePropertyLinkInfo();

  const isWelcomeTo = Boolean(logo || title);
  return (
    <SideBarContainer>
      <SideBarTitle>{isWelcomeTo ? t('welcome_to') : t('welcome')}</SideBarTitle>
      {isLoaded && (
        <>
          {logo && <SideBarLogo src={logo} alt="" width={240} height={88} />}
          {title && <SideBarPropertyName>{title}</SideBarPropertyName>}
        </>
      )}
    </SideBarContainer>
  );
}

export {SideBarUniversalLink};
